import React from 'react';
import styled from 'styled-components';

import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter';
import {oneDark} from 'react-syntax-highlighter/dist/esm/styles/prism';
import {ScreenSizes} from '../../types/responsive';

const Code = styled(SyntaxHighlighter)`
  border-radius: 4px;
  padding: 2em !important;
  overflow-x: hidden !important;
  @media (max-width: ${ScreenSizes.md}) {
    margin-top: 5sem !important;
  }
`;

export type Snippet = {
  code: string;
  language: string;
};

interface CodeSnippetProps {
  snippets: Snippet[];
}

const CodeSnippets = ({snippets}: CodeSnippetProps) => {
  return (
    <div>
      {snippets.map((snippet, index) => (
        <div key={index}>
          <Code language={snippet.language} style={oneDark} wrapLines>
            {snippet.code}
          </Code>
        </div>
      ))}
    </div>
  );
};

export default CodeSnippets;
